import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SupplierInvitationPage from './SupplierInvitationPage';

const SupplierInvitationRoutes = () => (
  <Switch>
    <Route
      path="/join/:token"
      exact
      component={SupplierInvitationPage}
    />
  </Switch>
);

export default SupplierInvitationRoutes;
